export default "/profile/images/CleverBox.png?414775cd689733427d3a7750799da116";